/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { getLogoTitle } from '../../helpers/serviceDeskHelpers';
import { INTELEPEER_BYOSD_TYPE } from '../../util/channelTypes';

interface IntelepeerIconMinimalProps {
  className?: string;
  size?: number;
}

export const IntelepeerIconMinimal = ({
  className,
  size = 32,
  ...others
}: IntelepeerIconMinimalProps) => {
  const intl = useIntl();
  const pxHeight = size + 'px';
  return (
    <svg
      className={cx('IntelepeerIconMinimal', className)}
      xmlns="http://www.w3.org/2000/svg"
      height={pxHeight}
      viewBox="0 0 360 360"
      {...others}>
      <title>{getLogoTitle(INTELEPEER_BYOSD_TYPE, intl)}</title>
      <g id="Intelepeer_Layer_2" data-name="Intelepeer Layer 2">
        <g id="Intelepeer_Layer_1-2" data-name="Intelepeer Layer 1">
          <g id="Circle_Logo" data-name="Circle Logo" fill="#2b92ff">
            <circle cx="180" cy="180" r="180" />
            <g
              id="Eye_Logo"
              data-name="Eye Logo"
              fill="#fff"
              fillRule="evenodd">
              <path
                id="Intelepeer_Minimal_Path_1"
                d="M207.35,181a30.56,30.56,0,1,1-30.56-30.53A30.54,30.54,0,0,1,207.35,181"
              />
              <path
                id="Intelepeer_Minimal_Path-2"
                data-name="Path"
                d="M180,76.59c-71.5,0-129.42,39.39-129.42,88,0,30,22.08,56.35,55.66,72.18l4.52-21.48c-20.37-12.25-33.2-30.53-33.2-50.89,0-36.75,41.88-66.52,93.38-66.52s93.39,29.77,93.39,66.52-41.88,66.53-93.39,66.53a123,123,0,0,1-31.88-4.15l-20.37,94.79,58.48-68.78H180c71.5,0,129.42-39.39,129.42-88,0-48.81-57.92-88.2-129.42-88.2"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
